import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { Button, Container, Icon } from 'semantic-ui-react'
import { FaTh } from 'react-icons/fa'
import { loadSubgenres, removeSubgenre, updateState } from '../Slice/SubgenreSlice'
import ListTable from '../../Common/Views/ListTable'
import DeleteConfirmModal from '../../Common/Views/DeleteConfirmModal'
import './css/SubgenreListPage.css'

export default function SubgenreListPage () {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {
    list,
    filter,
    totalPages,
    isLoading,
    isError,
    message
  } = useSelector((state) => state.subgenre)
  const [deleteSubgenre, setDeleteSubgenre] = useState({})

  const columns = [
    {
      name: 'id',
      title: 'generic.id',
      filter: false,
      props: {
        textAlign: 'right',
        width: 1
      }
    },
    {
      name: 'name',
      title: 'generic.name'
    },
    {
      name: 'tag',
      title: 'generic.tag'
    }
  ]

  useEffect(() => {
    onReload(filter)
  }, [])

  const onReload = (payload) => {
    dispatch(loadSubgenres(payload))
  }
  useEffect(() => {
    if (isError && message) {
      toast.error(message)
      dispatch(updateState())
    }
  }, [isError, message])

  const onEdit = (subgenreId) => {
    navigate(`/subgenre/${subgenreId}`)
  }
  const onDelete = (subgenre) => {
    setDeleteSubgenre(subgenre)
  }

  const handleDeleteCompany = () => {
    dispatch(removeSubgenre(deleteSubgenre.id))
    setDeleteSubgenre({})
  }

  return (
    <Container className='subgenre-list-page'>
      <div className='subgenre-title'>
        <Icon size='large'><FaTh /></Icon>
        <span>{ t('menu.subgenres') }</span>
        <Button
          floated='right'
          icon
          labelPosition='left'
          primary
          size='large'
          onClick={() => navigate('/subgenre/new')}>
          <Icon name='th' /> { t('subgenre.new') }
        </Button>
      </div>
      <ListTable color='teal'
                 isLoading={isLoading}
                 columns={columns}
                 filter={filter}
                 data={list}
                 totalPages={totalPages}
                 onReload={onReload}
                 onEdit={onEdit}
                 onDelete={onDelete} />
      <>
        <DeleteConfirmModal open={ !!deleteSubgenre.id }
                            title={ t('subgenre.deleteTitle') }
                            message={ t('subgenre.deleteQuestion') }
                            item={ deleteSubgenre.name }
                            onCancel={ () => setDeleteSubgenre({}) }
                            onDelete={ handleDeleteCompany } />
      </>
    </Container>
  )
}
